import {
    HttpEvent,
    HttpHandler,
    HttpInterceptor,
    HttpRequest
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable()
export class CurrentCultureInterceptor implements HttpInterceptor {
    constructor() {}

    private get selectedLanguage(): string {
        return sessionStorage.getItem('selectedLanguage') ?? 'en';
    }

    intercept(
        request: HttpRequest<unknown>,
        next: HttpHandler
    ): Observable<HttpEvent<unknown>> {
        request = this.addCurrentCulture(request);
        return next.handle(request);
    }

    private addCurrentCulture(request: HttpRequest<unknown>) {
        request = request.clone({
            setParams: { culture: this.selectedLanguage }
        });
        return request;
    }
}
